import React from "react";

import { Tab } from "../../UI/Tab";
import { TabList } from "../../UI/TabList";
import { TabPanel } from "../../UI/TabPanel";
import { Tabs } from "../../UI/Tabs";

import { MatchingActivity } from "./MatchingActivity";
import { MembershipDetailsTab } from "./MembershipDetailsTab";
import { ProfileTab } from "./ProfileTab";

export const UserTabs = () => (
  <Tabs id="user">
    <TabList>
      <Tab>Membership Details</Tab>
      <Tab>Profile</Tab>
      <Tab>Roommates</Tab>
    </TabList>
    <TabPanel>
      <MembershipDetailsTab />
    </TabPanel>
    <TabPanel>
      <ProfileTab />
    </TabPanel>
    <TabPanel>
      <MatchingActivity />
    </TabPanel>
  </Tabs>
);
